import React, { memo } from "react";

import { Text } from "@chakra-ui/react";
import colors from "app/colors";

interface IProps {
  text: string;
  icon?: React.ReactNode;
}

const ModalTitle = ({ text, icon }: IProps) => (
  <>
    {icon}
    <Text
      color={colors.blackSecondary}
      fontSize={24}
      fontWeight={700}
      fontStyle="Outfit"
    >
      {text}
    </Text>
  </>
);

export default memo(ModalTitle);
